import apiHttpClient from "./ApiHttpService";

export default class ObjectService {
  getObjectInfos() {
    return apiHttpClient.get(`trs/mobile/Object/getObjectInfos`);
  }
  getCarsInfos() {
    return apiHttpClient.get(`trs/mobile/Object/getCarsInfos`);
  }
}
